import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { AppButton, AppInput, AppModal, AppSpinner } from '../../components/ui';
import { resolveAgendaMediaUrl } from '../../config/agendaApiConfig';
import agendaDatesService from '../../services/agendaDatesService';

const AgendaMediaModal = ({ show, onClose, onSelect }) => {
  const [dir, setDir] = useState('');
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return undefined;
    const timer = setTimeout(() => setQuery(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search, show]);

  useEffect(() => {
    if (!show) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    agendaDatesService.medias({ q: query, dir: query ? '' : dir })
      .then((result) => {
        if (!cancelled) setData(result);
      })
      .catch((err) => {
        if (!cancelled) {
          setData(null);
          setError(err.message || 'Bibliothèque indisponible.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [show, dir, query]);

  const crumbs = (data?.dir || '').split('/').filter(Boolean);

  return (
    <AppModal
      show={show}
      title="Bibliothèque Agenda"
      onClose={onClose}
      size="lg"
      scrollable
      className="agenda-dates"
    >
      <div className="ag-library-tools">
        <label className="ag-search">
          <Icon icon="lucide:search" width={16} />
          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Nom de fichier"
          />
        </label>
        {query ? (
          <AppButton className="sw-btn sw-btn--page" variant="secondary" onClick={() => setSearch('')}>
            Voir les dossiers
          </AppButton>
        ) : (
          <div className="ag-crumbs">
            <button type="button" onClick={() => setDir('')}>images</button>
            {crumbs.map((crumb, index) => {
              const path = crumbs.slice(0, index + 1).join('/');
              return (
                <React.Fragment key={path}>
                  <span>/</span>
                  <button type="button" onClick={() => setDir(path)}>{crumb}</button>
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>

      {error ? <p className="ag-note">{error}</p> : null}
      {loading ? <AppSpinner /> : null}

      {!loading && data ? (
        <div className="ag-library">
          {!query && data.parent !== null && data.parent !== undefined ? (
            <button type="button" className="ag-library__folder" onClick={() => setDir(data.parent || '')}>
              <Icon icon="lucide:folder-up" width={28} />
              <span>Dossier parent</span>
            </button>
          ) : null}
          {(data.folders || []).map((folder) => (
            <button key={folder.path} type="button" className="ag-library__folder" onClick={() => setDir(folder.path)}>
              <Icon icon="lucide:folder" width={28} />
              <span>{folder.name}</span>
            </button>
          ))}
          {(data.files || []).map((file) => (
            <button
              key={file.path}
              type="button"
              className="ag-library__file"
              onClick={() => onSelect(file.path)}
            >
              <img src={resolveAgendaMediaUrl(file.path) || ''} alt="" />
              <span>{file.name}</span>
            </button>
          ))}
        </div>
      ) : null}
      {!loading && data && !(data.folders || []).length && !(data.files || []).length ? (
        <p className="ag-note">Aucune image dans cet emplacement.</p>
      ) : null}
    </AppModal>
  );
};

export default AgendaMediaModal;
